import { render, staticRenderFns } from "./overlay-backdrop.vue?vue&type=template&id=b868cd52&scoped=true&"
import script from "./overlay-backdrop.vue?vue&type=script&lang=js&"
export * from "./overlay-backdrop.vue?vue&type=script&lang=js&"
import style0 from "./overlay-backdrop.vue?vue&type=style&index=0&id=b868cd52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b868cd52",
  null
  
)

export default component.exports